import type { Lesson } from "@otto/lehrgang";
import own from "./StageDots.module.css";

/**
 * Progress as a row of dots instead of "stage 1 of 3" — for children who do not
 * read fluently yet. The label stays for screen readers.
 */
export function StageDots({
  lesson,
  doneCount,
  currentIndex,
  allDone,
}: {
  lesson: Lesson;
  doneCount: number;
  currentIndex: number | null;
  allDone: boolean;
}) {
  return (
    <div
      className={own.dots}
      aria-label={`Stufe ${Math.min(doneCount + 1, lesson.stages.length)} von ${lesson.stages.length}`}
    >
      {lesson.stages.map((stage, i) => (
        <span
          key={stage.key}
          className={[
            own.dot,
            i < doneCount || allDone ? own.dotDone : "",
            i === currentIndex ? own.dotCurrent : "",
          ]
            .filter(Boolean)
            .join(" ")}
        />
      ))}
    </div>
  );
}
